export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./redpipe.vue?vue&type=template&id=dd65eec2&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/redpipe.vue?vue&type=template&id=dd65eec2&scoped=true
// module id = kxwQ
// module chunks = 0